import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import ContentWrapper from '../components/contentwrapper/ContentWrapper'
import { Link } from 'react-router-dom'
import { AiFillEdit, AiOutlinePlus } from 'react-icons/ai'
import { activeStatus, fetchAllDataAPI, removeDataFromList } from '../utils/api'
import { toast } from 'react-toastify'
import LoadingSpinner from '../components/LoadingSpinner'
import Swal from 'sweetalert2'
import { VscTrash } from "react-icons/vsc";
import moment from 'moment'
import { Table } from 'react-bootstrap'
import Skeleton from 'react-loading-skeleton'

const Award = () => {
    const [award, setAward] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const recordPerPage = 10;
    const lastIndex = currentPage * recordPerPage;
    const firstIndex = lastIndex - recordPerPage;
    const records = award.slice(firstIndex, lastIndex);
    const npage = Math.ceil(award.length / recordPerPage)
    const numbers = [...Array(npage + 1).keys()].slice(1)

    useEffect(() => {
        getAward();
    }, []);

    const getAward = () => {
        setIsLoading(true);
        fetchAllDataAPI(`hr-all-award`).then((res) => {
            if (res.data.status === 1) {
                setIsLoading(false);
                setAward(...[res.data.award]);
            }
            else {
                toast.error("Check you connection!!");
            }
        })
    }
    const handleStatusActive = (awardid) => {
        activeStatus('hr-active-award-status', awardid).then((res) => {
            if (res.data.status === 1) {
                getAward();
            }
        })
    }
    const handleStatusInactive = (awardid) => {
        activeStatus('hr-inactive-award-status', awardid).then((res) => {
            if (res.data.status === 1) {
                getAward();
            }
        })
    }
    const handleRemoveAward = (awardid) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'danger',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
        }).then((result) => {
            if (result.isConfirmed) {
                removeDataFromList('hr-remove-award', awardid).then((res) => {
                    if (res.data.status === 1) {
                        Swal.fire(
                            'Deleted!',
                            'Your file has been deleted.',
                            'success'
                        )
                        getAward();
                    }
                })
            }
            else if (
                result.dismiss === Swal.DismissReason.cancel
            ) {
                Swal.fire(
                    'Cancelled',
                    'Your imaginary file is safe :)',
                    'error'
                )
            }
        })
    }
    return (
        <div className="awardPage">
            <Helmet>
                <title>SATKARTAR::HR::AWARD</title>
            </Helmet>
            <ContentWrapper>
                <div className="card employeepage">
                    <h4 className="mb-0 text-uppercase">
                        All Award
                        <Link to="/add-award" className="btn btn-primary btnemployee"><AiOutlinePlus /> Add Award</Link>
                    </h4>
                    <div className="table pagetable table-responsive">
                        <Table className="table-sm table-fixeds" responsive striped bordered hover>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Award Name</th>
                                    <th>Employee Name</th>
                                    <th>Award Date</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading ? (
                                    <>
                                        {[...Array(5)].map((_, index) => (
                                            <tr key={index}>
                                                {Array.from({ length: 6 }).map((_, index) => (
                                                    <td key={index}><Skeleton animation="wave" variant="text" /></td>
                                                ))}
                                            </tr>
                                        ))}
                                    </>
                                ) : records.length > 0 ? (records?.map((award, index) => (
                                    <tr key={award?.award_id}>
                                        <td>{index + 1}</td>
                                        <td>{award?.award_name}</td>
                                        <td>{award?.emp_name}</td>
                                        <td>{moment(award?.award_date).format('dddd Do MMMM YYYY')}</td>
                                        <td>
                                            {(() => {
                                                if (award?.award_status === "Active") {
                                                    return (
                                                        <span className="badge bg-success btnstatus" onClick={() => handleStatusActive(award?.award_id)}>Active</span>
                                                    )
                                                }
                                                else {
                                                    return (
                                                        <span className="badge bg-danger btnstatus" onClick={() => handleStatusInactive(award?.award_id)}>Inactive</span>
                                                    )
                                                }
                                            })()}
                                        </td>
                                        <td>
                                            <div className="d-flex" style={{ gap: "5px" }}>
                                                <Link to={`/edit-award/${award?.award_id}`} className="btnEdit"><AiFillEdit /></Link>
                                                <button className="btnDelete" onClick={() => handleRemoveAward(award?.award_id)}><VscTrash /></button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                                ) : (
                                    <tr>
                                        <td className="text-center" colSpan={6}>Data not found...</td>
                                    </tr>
                                )}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th>#</th>
                                    <th>Award Name</th>
                                    <th>Employee Name</th>
                                    <th>Award Date</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </tfoot>
                        </Table>
                        <nav>
                            <ul className="pagination justify-content-end round-pagination">
                                <li className="page-item">
                                    <a href="#" className="page-link" onClick={perPage}>Previous</a>
                                </li>
                                {
                                    numbers.map((n, i) => (
                                        <li className={`page-item ${currentPage === n ? 'active' : ''}`} key={i}>
                                            <a href="#" className="page-link" onClick={() => changePage(n)}>{n}</a>
                                        </li>
                                    ))
                                }
                                <li className="page-item">
                                    <a href="#" className="page-link" onClick={nextPage}>Next</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </ContentWrapper>
        </div>
    )
    function perPage() {
        if (currentPage !== 1) {
            setCurrentPage(currentPage - 1)
        }
    }
    function changePage(id) {
        setCurrentPage(id)
    }
    function nextPage() {
        if (currentPage !== npage) {
            setCurrentPage(currentPage + 1)
        }
    }
}

export default Award